<template>
  <div class="keyword">
    <div class="layer" :style="keywords || 'height:100vh'">
      <!-- 搜索部分加相似关键词 -->
      <div class="search-box width">
        <div>
          <el-input placeholder="请输入内容" v-model="keyword" clearable></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getData()"
            :disabled="!keyword"
            style="background: #75867c;"
          >搜索</el-button>
          <el-checkbox v-model="checked">模糊匹配</el-checkbox>
        </div>
        <div class="search-simkeyword" v-if="keywords" v-loading="loading2">
          <span>相似关键词:</span>
          <span  v-for="(item,index) in relatedKeywordList" :key="index" class="simkeyword" @click="simkeySearch(item.name)">{{item.name}}</span>
        </div>
      </div>
      <!-- 图表部分 -->
      <div class="search-box width" v-if="keywords" v-loading="loading5">
        <span>{{keywords}}</span>
        <span style="color: #1e70bf;font-weight: 600;">{{keywordTranslation}}</span>
      </div>
      <el-row class="keyword-box width" :gutter="10" v-if="keywords">
        <el-col :span="6">
          <div class="simkeyword segment hone" v-loading="loading1">
            <div class="com-tit">相似关键词</div>
            <div class="simkeywords" v-if="simkeywordsList.length">
              <a v-for="(item,index) in simkeywordsList.slice(0,30)" :key="index">{{item.name}}</a>
            </div>
            <div v-else class="none">未有相似关键词</div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="cnkeyword segment hone" v-loading="loading1">
            <div class="com-tit">中文关联关键词关系</div>
            <wordcloud-Chart
              v-if="keyCnList.length"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              :WordCloudList="keyCnList"
              :isClick="isClick"
              :retrieve="isClick"
              id="CNChart"
              height="100%"
              width="100%"
            />
            <div v-else class="none">未有中文关联关键词关系</div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="enkeyword segment hone" v-loading="loading1">
            <div class="com-tit">英文关联关键词关系</div>
            <wordcloud-Chart
              v-if="keyEnList.length"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              id="ENChart"
              :WordCloudList="keyEnList"
              :isClick="isClick"
              :retrieve="isClick"
              height="100%"
              width="100%"
            />
            <div v-else class="none">未有英文关联关键词关系</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="keyword-box width" :gutter="10" v-if="keywords">
        <el-col :span="12">
          <div class="cnkeyword segment htwo" v-loading="loading2">
            <div class="com-tit">围绕该关键词的专家图网</div>
            <wordcloud-Chart
              v-if="creatorsList.length"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              :WordCloudList="creatorsList"
              :isClick="isClick"
              :retrieve="isClick"
              id="EXPChart"
              height="100%"
              width="100%"
            />
            <div v-else class="none">未有围绕该关键词的专家图网</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="enkeyword segment htwo" v-loading="loading1">
            <div class="com-tit">该关键词历史热度</div>
            <LineMaxMin-Chart
              v-if="historyList.length"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              :tit="tit"
              class="line"
              id="HOTChart"
              height="400px"
              width="100%"
              :LineMaxMinList="historyList"
            />
            <div v-else class="none">未有围绕该关键词的专家图网</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="keyword-box width" style="height:60rem;" :gutter="10" v-if="keywords">
        <el-col :span="24">
          <div class="cnkeyword segment snakey" v-loading="loading3">
            <div class="com-tit">该关键词的学科、期刊和年度分布情况</div>
            <ul class="areapos clearfix">
              <li>关键词</li>
              <li>学科</li>
              <li>期刊</li>
              <li>年份</li>
            </ul>
            <sankey-Chart
              v-if="Object.keys(sankeyList).length"
              :sankeyList="sankeyList"
              id="EXPChart"
              height="55rem"
              width="100%"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
            />
            <div v-else class="none" style="height:60em">未有该关键词的学科、期刊和年度分布情况</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="keyword-box width" :gutter="20" v-if="keywords">
        <el-col :span="10">
          <div class="cont-exp segment" v-loading="loading4">
            <div class="com-tit">该关键词早期提出专家</div>
            <div class="content">
              <div class="border-r" v-if="creatorList.length">
                <div
                  class="expitem clearfix"
                  v-for="(item,index) in creatorList"
                  :key="index"
                  v-show="item.creator !==  '无'"
                >
                  <div class="creator" @click="goSearch(item.creator)">
                    <div class="avatar">
                      <div class="surname">{{item.creator? item.creator.substr(0,1):'无' }}</div>
                    </div>
                    <div class="name">{{item.creator || '无'}}</div>
                  </div>
                  <div class="introduction">
                    <div class="description">
                      <div class="text">机构：{{item.institute || '暂无机构'}}</div>
                      <div class="text">学科：{{item.subject||'暂无学科信息'}}</div>
                    </div>
                    <div class="paper">
                      <div class="text">期刊：{{item.journal||'暂无期刊信息'}}</div>
                      <div class="text">
                        论文：
                        <a :href="item.url" v-if="item.url" target="_blank">
                          {{item.title}}
                          <span v-if="item.year">({{item.year}})</span>
                        </a>
                        <span v-if="!item.url">
                          {{item.title}}
                          <span v-if="item.year">({{item.year}})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="creator-time-line">
                    <div class="creator-time-spot"></div>
                    <div class="creator-time-year">{{item.year}}</div>
                  </div>
                </div>
              </div>

              <div v-else class="none">未有该关键词早期提出专家</div>
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="cont-paper segment" v-loading="loading2">
            <div class="com-tit">涵盖该关键词论文</div>
            <el-select
              v-model="value"
              placeholder="请选择"
              class="timesort"
              size="small"
              @change="select()"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="content">
              <div class="paperitem" v-for="(item,index) in paperList" :key="index">
                <a :href="item.url" v-if="item.url" class="title" target="_blank">{{item.title}}</a>
                <span v-if="!item.url" class="title">{{item.title}}</span>
                <div class="tag">
                  <a
                    v-if="item.source === 2 || item.source === 6 || item.source === 10 || item.source === 14"
                    :href="item.url"
                    target="_blank"
                  >CNKI</a>
                  <a
                    v-if="item.source === 4 || item.source === 6 || item.source === 12 || item.source === 14"
                    :href="item.url"
                    target="_blank"
                  >万方</a>
                  <a
                    v-if="item.source === 8 || item.source === 10 || item.source === 12 || item.source === 14"
                    :href="item.url"
                    target="_blank"
                  >维普</a>
                </div>
                <div class="papertext">
                  <span v-if="item.page">({{item.page}})</span>
                  {{item.year}}
                </div>
                <div class="papertext">{{item.creatorAll}}</div>
                <div class="papertext">{{item.keyword}}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/Charts/LineChart'
import WordcloudChart from '@/components/Charts/WordcloudChart'
import LineMaxMinChart from '@/components/Charts/LineMaxMinChart'
import sankeyChart from '@/components/Charts/sankeyChart'
import {
  searchCoreKeywordsv2,
  getRelatedKeyword,
  getKeywordTranslate,
  getKeywordAnalysis,
  getSankeychart
} from '@/api/keyword'

export default {
  name: 'Keyword',
  components: {
    WordcloudChart,
    LineChart,
    LineMaxMinChart,
    sankeyChart
  },
  data () {
    return {
      keyword: this.$route.query.keyword || '', // 关键词
      keywords: '', // 关键词
      checked: false, // 模糊匹配
      relatedKeywordList: [], // 相似关键词搜索下方
      keywordTranslation: '', // 关键词翻译
      keyCn: '', // 中文翻译
      simkeywordsList: [], // 相识关键词数组
      keyEnList: [], // 英文关联关键词数组
      keyCnList: [], // 中文关联关键词数组
      tit: '', // 历史热度图表标题
      historyList: [], // 历史热度数组
      creatorList: [], // 提出专家数组
      sankeyList: {}, // 领域数组
      creatorsList: [], // 专家网图数组
      paperList: [], // 关键词论文
      loading1: false, // 加载动画1
      loading2: false, // 加载动画2
      loading3: false, // 加载动画3
      loading4: false, // 加载动画4
      loading5: false, // 加载动画4
      isClick: true, // 词云图是否有点击事件
      options: [
        {
          value: '1',
          label: '按时间降序'
        },
        {
          value: '2',
          label: '按时间升序'
        }
      ],
      value: '1',
      isKeyword: 0 // 判断是否可以查询该关键词
    }
  },
  mounted () {
    if (this.keyword) {
      this.getData()
    }
  },
  methods: {
    // 获取数据
    getData (key) {
      this.isKeyword = 0
      this.keywords = this.keyword
      this.loading1 = true
      this.loading2 = true
      this.loading4 = true
      this.loading5 = true
      this.clear()
      let data1 = {
        e: !this.checked,
        k: this.keyword,
        s: 'desc'
      }
      let data2 = {
        k: this.keyword
      }
      let data3 = {
        e: !this.checked,
        k: this.keyword,
        s: ''
      }
      // 相识关键词图表  历史热度
      getKeywordAnalysis(data1)
        .then(res => {
          if (!res.data.relatedKeywords.length) {
            this.isQuery()
          }
          this.simkeywordsList = res.data.relatedKeywords
          this.historyList = res.data.years.slice(0, res.data.years.length - 1)
          this.tit = this.keywords + '历史热度'
          this.loading1 = false
        })
        .catch(err => {
          console.log(err)
        })
      // 翻译
      getKeywordTranslate(data2)
        .then(res => {
          this.loading5 = false

          this.keywordTranslation = res.data.data[0].keyEn
          this.keyCn = res.data.data[0].keyCn
          if (res.data.data.length && this.keyCn) {
            this.loading3 = true

            this.getSankey()
          }
          this.getKeyWord()
        })
        .catch(err => {
          console.log(err)
        })
      // 提出专家
      getKeywordAnalysis(data3)
        .then(res => {
          if (!res.data.obj.length) {
            this.isQuery()
          }
          this.loading4 = false
          this.creatorList = res.data.obj
        })
        .catch(err => {
          console.log(err)
        })
      this.getRelat()
    },
    // 相识关键词查询
    simkeySearch (data) {
      this.keyword = data
      this.getData()
    },
    // 涉及领域
    getSankey () {
      if (!this.keywordTranslation) {
        return
      }
      let data = {
        isExact: true,
        keyword: this.keyCn + ';' + this.keywordTranslation
      }
      getSankeychart(data)
        .then(res => {
          this.loading3 = false
          this.sankeyList = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 英文词云
    getKeyWord () {
      let data = {
        keyword: this.keywords
      }
      searchCoreKeywordsv2(data)
        .then(res => {
          this.keyEnList = res.data.data.enkeyword.map(it => {
            return {
              name: it.key,
              count: it.doc_count
            }
          })
          this.keyCnList = res.data.data.cnkeyword.map(it => {
            return {
              name: it.key,
              count: it.doc_count
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 专家网图   关键词论文 相似关键词搜索框下
    getRelat () {
      this.loading2 = true
      let data = {
        keyword: this.keyword,
        keywordCount: 10,
        sort: this.value === '1' ? 'desc' : 'asc'
      }
      getRelatedKeyword(data)
        .then(res => {
          if (!res.creators.length) {
            this.isQuery()
          }
          this.loading2 = false
          res.creators.forEach((item, index) => {
            if (item.key === '无' || item.key === '佚名') {
            } else {
              let temp = {
                count: item.doc_count,
                name: item.key
              }
              this.creatorsList.push(temp)
            }
          })
          this.paperList = res.obj
          this.relatedKeywordList = res.relatedKeywords
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 如果都没有数据
    isQuery () {
      this.isKeyword++
      if (this.isKeyword === 3) {
        this.keywords = ''
        this.$alert('暂无该关键词数据', '提示', {
          confirmButtonText: '确定',
          center: true,
          type: 'warning',
          callback: action => {}
        })
      }
    },
    select () {
      this.getRelat()
    },
    // 跳转到检索
    goSearch (name) {
      if (name) {
        let routeUrl = this.$router.resolve({
          path: '/Loading',
          query: {
            data: name + ' ' + this.keywords
          }
        })
        localStorage.setItem('val', name + ' ' + this.keywords)
        window.open(routeUrl.href, '_blank')
      }
    },
    // 全部清除
    clear () {
      this.isKeyword = 0
      this.relatedKeywordList = [] // 相似关键词搜索下方
      this.keywordTranslation = ''
      this.keyCn = ''
      this.simkeywordsList = []
      this.keyEnList = []
      this.keyCnList = []
      this.historyList = []
      this.creatorList = []
      this.sankeyList = {}
      this.creatorsList = [] // 专家网图数组
      this.paperList = []
    }
  }
}
</script>

<style lang="scss">
.keyword {
  background-color: #f5f5f5;
  .search-box {
    margin: 30px 0;
    font-size: 1.2em;
    border-top: 2px solid #75877b;
    padding: 20px;
    background: white;
    .el-input {
      width: 30%;
    }
    .hotkeywords {
      font-size: 12px;
      margin-top: 5px;
    }
    .search-simkeyword {
      margin-top: 10px;
      .simkeyword {
        background: 0 0;
        color: #5983a9;
        margin: 1rem;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
  .keyword-box {
    .none {
      text-align: center;
      margin-top: 100px;
    }
    .hone {
      height: 320px;
    }
    .htwo {
      height: 450px;
    }
    .snakey {
      height: 100%;
    }
    .segment {
      position: relative;
      border-top: 2px solid #75877b;
      background: #ffffff;
      margin-bottom: 10px;
      .areapos {
        position: relative;
        left: 87px;
        top: 40px;
        li {
          float: left;
          width: 25%;
          font-size: 12px;
        }
      }
    }
    .simkeyword {
      .simkeywords {
        padding: 10px;
        a {
          display: inline-block;
          font-weight: 500;
          font-size: 12px;
          padding: 0 10px;
          border: 1px #eaeaea solid;
          color: #75867c;
          margin: 4px 5px;
          border-radius: 2px;
        }
      }
    }
    .cont-exp {
      height: 90rem;
      .content {
        width: 100%;
        padding: 15px;
        .border-r {
          border-right: 4px solid #eaeaea;
          .expitem {
            position: relative;
            width: 90%;
            box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
            border: 1px solid rgba(34, 36, 38, 0.15);
            border-radius: 3px;
            margin-bottom: 8px;
            display: flex;
            .creator {
              height: 125px;
              padding: 10px;
              border-right: 1px solid #eaeaea;
              text-align: center;
              overflow: hidden;
              cursor: pointer;
              .avatar {
                width: 70px;
                .surname {
                  border: 4px solid rgb(234, 234, 234);
                  border-radius: 50%;
                  height: 100%;
                  width: 100%;
                  line-height: 64px;
                  font-size: 28px;
                  background: #75867c;
                  color: rgba(255, 255, 255, 0.8);
                }
              }
              .name {
                font-size: 14px;
              }
            }
            .introduction {
              width: 76%;
              font-size: 14px;
              .text {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .description {
                padding: 5px;
                line-height: 26px;
              }
              .paper {
                padding: 5px;
                border-top: 1px solid #75877b;
                line-height: 26px;
              }
            }
            .creator-time-line {
              box-sizing: inherit;
              .creator-time-spot {
                position: absolute;
                top: 45%;
                right: -12.5%;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background: rgba(0, 147, 221, 0.8);
                border: 3px solid rgba(255, 255, 255, 0.6);
              }
              .creator-time-year {
                position: absolute;
                font-size: 14px;
                top: 42%;
                right: -8%;
              }
            }
          }
        }
      }
    }
    .cont-paper {
      height: 90rem;
      .timesort {
        position: absolute;
        right: 0;
        top: 0;
      }
      .content {
        padding: 0 15px;
        .paperitem {
          position: relative;
          padding: 10px 0;
          border-bottom: 1px solid #eaeaea;
          .title {
            font-size: 16px;
            color: #8ca9ad;
          }
          .tag {
            float: right;
            a {
              display: inline-block;
              line-height: 1;
              vertical-align: baseline;
              font-size: 12px;
              padding: 4px 8px;
              margin-left: 8px;
              border: 1px solid rgba(34, 36, 38, 0.15);
              border-radius: 3px;
            }
            a :hover {
              color: #1e70bf;
            }
          }
          .papertext {
            font-size: 12px;
            color: #999999;
            line-height: 16px;
            padding: 0 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Keyword.vue